<template>
  <div class="container">
    <el-dialog title="测试编带机随工单" center :visible.sync="dialogVisible" width="80%">
      <div v-if='editRow' class="title_container">
        <span class="title_text">子批号:<span class="content_text">{{editRow.subNo}}</span></span>
        <span class="title_text">产品型号:<span class="content_text">{{editRow.product.productName + '/' + editRow.product.chipName}}</span></span>
        <span class="title_text">印章号:<span class="content_text">{{editRow.lotNo}}</span></span>
        <span class="title_text">数量:<span class="content_text">{{editRow.count}}</span></span>
        <span class="title_text">封装厂:<span class="content_text"></span></span>
        <span class="title_text">加工项目:<span class="content_text">{{processTypeVal(editRow.processType)}}</span></span>
      </div>
      <el-table
        ref="outTable"
        height="400px"
        border
        :data="boxList"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column
              type="index"
              label="序号"
              width="50">
            </el-table-column>
        <el-table-column min-width="100" prop="boxNo" label="箱号"/>
        <el-table-column min-width="300" prop="barcode" label="箱号条形码">
          <template slot-scope="scope">
            <!-- <div :v-html='<img :id="'barcode' + scope.$index"/>'></div> -->
            <!-- <img :id="'barcode' + scope.$index" style="width: 200px;"/> -->
            <img v-if='scope.row.barcode' :src="scope.row.barcode"/>
          </template>
        </el-table-column>
        <el-table-column min-width="100" prop="count" label="数量"/>
        <!-- <el-table-column min-width="100" prop="comment" label="备注"/> -->
        <!-- <el-table-column min-width="100" label="统计结果"/> -->
        </el-table>
        <span slot="footer">
                  <el-button class="cancelButton" size="small" @click="dialogVisible = false">取消</el-button>
                  <el-button :disabled="!(boxList && boxList.length > 0)" :loading="loadingMain" type="primary" size="small" @click="batchExport()">导出</el-button>
              </span>
    </el-dialog>
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.orderNo') + ':'" prop="incoOrderNo">
        <el-input
          v-model.trim="form.incoOrderNo"
          name="incoOrderNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.customerName') + ':'" prop="customerId">
        <el-select
          v-model="form.customerId"
          clearable
          filterable
          size="small"
          style="width: 200px;">
          <el-option
            v-for="item in customersList"
            :key="item.id"
            :label="item.customerName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.productName') + ':'" prop="productName">
        <el-select
          v-model="form.productId"
          clearable
          filterable
          style="width: 200px;"
          size="small">
          <el-option
            v-for="item in productsList"
            :key="item.id"
            :label="item.productName + ' / ' + item.chipName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.lotNo') + ':'" prop="lotNo">
        <el-input
          v-model.trim="form.lotNo"
          name="lotNo"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 150px;"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.status') + ':'" prop="status">
        <el-select
          v-model="form.status"
          clearable
          filterable
          style="width: 150px;"
          size="small">
          <el-option
            v-for="(item, key) in incomingOrderStatus"
            :key="key"
            :label="item.explain"
            :value="item.val">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.orderDate') + ':'" prop="orderDate">
        <el-date-picker
          v-model="form.orderDate"
          type="daterange"
          size="small"
          clearable
          style="width: 250px;"
          :picker-options="pickerOptions"
          :default-value="defaultTime">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button type="primary" size="small" @click="queryOrderRecord">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <!-- <img id="barcode"/> -->
    <div class="control-container">
      <router-link to="/incoming-order/create">
        <el-button type="warning" size="small">
          {{$t('common.new')}}
        </el-button>
      </router-link>
    </div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName"
        :row-class-name="tableRowClassName">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              max-height="400"
              border
              :data="props.row.incoOrdersDetails"
              :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
              :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
              header-cell-class-name="headerCellName"
              :row-class-name="tableRowClassName">
              <el-table-column prop="subNo" :label="$t('common.subNo')"/>
              <el-table-column :label="$t('common.productName')">
                <template slot-scope="scope">
                  {{productName(scope.row)}}
                </template>
              </el-table-column>
              <el-table-column prop="lotNo" width="200" :label="$t('common.lotNo')"/>
              <el-table-column width="100" :label="$t('common.processType')">
                <template slot-scope="scope">
                  {{processTypeVal(scope.row.processType)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="endDevicen"
                :label="$t('common.endDevicen')">
              </el-table-column>
              <el-table-column prop="count" width="100" :label="$t('common.count')"/>
              <el-table-column prop="incoCount" width="100" :label="$t('incomingOrder.incoCount')"/>
              <el-table-column prop="finishCount" width="100" :label="$t('incomingOrder.finishCount')"/>
              <el-table-column width="100" :label="$t('incomingOrder.sendCount')">
                <template slot-scope="scope">
                  {{scope.row.sendFailCount + scope.row.sendPassCount}}
                </template>
              </el-table-column>
              <el-table-column  width="100" :label="$t('common.sendNum')">
                <template slot-scope="scope">
                  {{scope.row.passCount + scope.row.failCount - scope.row.sendPassCount - scope.row.sendFailCount}}
                </template>
              </el-table-column>
              <el-table-column  width="100" :label="$t('common.waitNum')">
                <template slot-scope="scope">
                  {{getwaitNum(scope.row)}}
                </template>
              </el-table-column>
              <el-table-column width="80" :label="$t('common.status')">
                <template slot-scope="scope">
                  {{storeStatusVal(scope.row.status)}}
                </template>
              </el-table-column>
              <el-table-column width="80" label="导出">
                <template  slot-scope="scope">
                  <el-button :disabled="scope.row.status === 0"  type="text" class="link" @click="exportExcel(scope.row)">
                    导出
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="incoOrderNo" :label="$t('common.orderNo')"/>
        <el-table-column :label="$t('common.customerName')">
          <template slot-scope="scope">
            {{scope.row.customer && scope.row.customer.customerName}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.productName')">
          <template slot-scope="scope">
            <p v-for="item in scope.row.prodNoChipName" :key="item">
              {{item}}
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="count" width="100" :label="$t('common.count')"/>
        <el-table-column prop="incoCount" width="100" :label="$t('incomingOrder.incoCount')"/>
        <el-table-column prop="finishCount" width="100" :label="$t('incomingOrder.finishCount')"/>
        <el-table-column width="100" :label="$t('incomingOrder.sendCount')">
          <template slot-scope="scope">
            {{scope.row.sendFailCount + scope.row.sendPassCount}}
          </template>
        </el-table-column>
        <el-table-column  width="100" :label="$t('common.sendNum')">
          <template slot-scope="scope">
            {{scope.row.passCount + scope.row.failCount - scope.row.sendPassCount - scope.row.sendFailCount}}
           </template>
         </el-table-column>
         <el-table-column  width="100" :label="$t('common.waitNum')">
           <template slot-scope="scope">
               {{getwaitNum(scope.row)}}
             </template>
         </el-table-column>
        <el-table-column width="80" :label="$t('common.status')">
          <template slot-scope="scope">
            {{storeStatusVal(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column width="100" :label="$t('common.orderDate')">
          <template slot-scope="scope">
            {{formatDate(scope.row.orderDate)}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('common.operate')"
          width="180">
          <template slot-scope="scope">
            <el-button v-if="!scope.row.isFinished" :disabled="disableFinishedIncoOrder(scope.row)" :class="{'is-disabled': disableFinishedIncoOrder(scope.row)}" type="text" class="link" @click="incoOrderCanBeFinishedGet(scope.row)">
              {{$t('common.complete')}}
            </el-button>
            <el-button v-if="scope.row.isFinished" type="text" class="link" @click="calcelFinishIncoOrderPut(scope.row)">
              {{$t('common.cancelFinish')}}
            </el-button>
            <el-button
              type="text"
              class="link"
              :disabled="disableDeleteIncoOrder(scope.row)"
              @click="deleteIncoOrder(scope.row)"
              :class="{'is-disabled': disableDeleteIncoOrder(scope.row)}">
              {{$t('common.delete')}}
            </el-button>
            <router-link :to="'/incoming-order/edit/' + scope.row.incoOrderNo">
              <el-button type="text" class="link" >
                {{$t('common.detail')}}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { processTypes, incomingOrderStatus, storeStatus } from '@/utils/defines';
import { incoOrderList, incoOrderDelete,incoOrderCanBeFinishedGet,finishIncoOrderPut,calcelFinishIncoOrderPut } from '@/api/incoOrder';
import {
    incoStorageList,
  } from '@/api/incoStorage';
import { customersList } from '@/api/customers';
import { productsList } from '@/api/products';
import { isValueEmpty } from '@/utils';
import exportBoxXlsx from "@/utils/exportBox";
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import jsbarcode from 'jsbarcode'
// import table2excel from 'js-table2excel'
import * as ExcelJs from 'exceljs/dist/exceljs'
import {
  Pagination,
} from '@/components';

const defaultForm = {
  incoOrderNo: undefined,
  customerId: undefined,
  productId: undefined,
  lotNo: undefined,
  orderDate: undefined,
  status: undefined,
};

export default {
  name: 'IncomingOrderList',
  components: {
    Pagination,
  },
  data() {
    const processTypesObj = {};
    let processTypeItem;
    for (const key in processTypes) {
      if (Object.prototype.hasOwnProperty.call(processTypes, key)) {
        processTypeItem = processTypes[key];
        processTypesObj[processTypeItem.val] = processTypeItem.explain;
      }
    }
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.explain;
      }
    }
    return {
      form: Object.assign({}, defaultForm),
      searchParams: Object.assign({}, defaultForm),
      rules: {
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      customersList: [],
      productsList: [],
      incomingOrderStatus,
      processTypesObj,
      storeStatusObj,
      dialogVisible: false,
      loadingMain: false,
      boxList: [],
      editRow: undefined
    };
  },
  computed: {
    displayData() {
      return this.listData;
    },
    pickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > moment().add(1, 'days').valueOf();
        },
      };
    },
    defaultTime() {
      return moment().subtract(1, 'months').valueOf();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.incoOrderList();
    })
  },
  mounted() {
    this.customersListGet(1, 200);
    this.productsListGet(1, 200);
  },
  methods: {
    tableRowClassName({ rowIndex, row }) {
      let className = '';
      if (rowIndex % 2 === 0) {
        className = 'evenTableRow';
      } else {
        className = 'oddTableRow';
      }
      if (this.editRow && (row.id === this.editRow.incoOrderId || row.id === this.editRow.id) ) {
        className += ' currentTableRow';
      }
      return className;
    },
    get_size(base64) {
        //确认处理的是png格式的数据
        if (base64.substring(0,22) === 'data:image/png;base64,') {
            // base64 是用四个字符来表示3个字节
            // 我们只需要截取base64前32个字符(不计开头那22个字符)便可（24 / 3 * 4）
            // 这里的data包含12个字符，9个字节，除去第1个字节，后面8个字节就是我们想要的宽度和高度
            const data = base64.substring(22 + 20, 22 + 32);
            const base64Characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
            const nums = [];
            for (const c of data) {
                nums.push(base64Characters.indexOf(c));
            }
            const bytes = [];
            for(let i = 0; i < nums.length; i += 4) {
                bytes.push((nums[i] << 2) + (nums[i+1] >> 4));
                bytes.push(((nums[i+1] & 15) << 4) + (nums[i+2] >> 2));
                bytes.push(((nums[i+2] & 3) << 6) + nums[i+3]);
            }
            const width = (bytes[1] << 24) + (bytes[2] << 16) + (bytes[3] << 8) + bytes[4];
            const height = (bytes[5] << 24) + (bytes[6] << 16) + (bytes[7] << 8) + bytes[8];
            console.log('width = ' + width);
            console.log('height = ' + height);
            return {width,height};
        }
        return 0;
    },
    batchExport(){
      this.loadingMain = true;
    // 创建一个工作簿
      const workbook = new ExcelJs.Workbook();
      const worksheet = workbook.addWorksheet('sheet1');

      // // 通过 base64  将图像添加到工作簿
      // let box = this.boxList[0];
      // const myBase64Image = box.barcode;
      // console.log('myBase64Image');
      // console.log(myBase64Image)
      // const imageId2 = workbook.addImage({
      //   base64: myBase64Image,
      //   extension: 'png',
      // });
      // worksheet.addImage(imageId2, 'B2:B2');

      // worksheet.addImage(imageId2, {
      //   tl: { col: 0, row: 0 },
      //   ext: { width: 500, height: 200 }
      // });


      // 修改/添加单个单元格
      worksheet.getCell('A1').value = '测试编带机随工单';
      worksheet.getCell('A1').alignment = { vertical: 'center', horizontal: 'center' };
      worksheet.getCell('A1').font = {
        size: 16,
        bold: true
      };
      worksheet.mergeCells('A1:F1');

      worksheet.getCell('A2').value = '产品型号';
      worksheet.getCell('B2').value = '印章号';
      worksheet.getCell('C2').value = '子批号 ' + this.editRow.subNo;
      worksheet.getCell('D2').value = '数量';
      worksheet.getCell('E2').value = '封装厂';
      worksheet.getCell('F2').value = '加工项目';

      let processType = this.processTypeVal(this.editRow.processType)
      // exportBoxXlsx(this.boxList,this.editRow, processType);

      //worksheet.getCell('A3').value = this.editRow.subNo;

      let img = document.createElement('canvas');
      jsbarcode(img, this.editRow.subNo, {
              lineColor: '#000',
              height: 40,
              width: 1,
              displayValue: false
            });
      const base64Image = img.toDataURL("image/png");
      let base64Obj = this.get_size(base64Image);
      const imageId = workbook.addImage({
        base64: base64Image,
        extension: 'png',
      });
      worksheet.getRow(3).height = 60;
      //worksheet.addImage(imageId, `C3:C3`);
      worksheet.addImage(imageId, {
        tl: { col: 2.1, row: 2.4 },
        ext: { width: base64Obj.width, height: base64Obj.height }
      });


      worksheet.getCell('A3').value = this.editRow.product.productName + '/' + this.editRow.product.chipName;
      worksheet.getCell('B3').value = this.editRow.lotNo;
      worksheet.getCell('D3').value = this.editRow.count + '';
      worksheet.getCell('E3').value = '';
      worksheet.getCell('F3').value = processType;

      worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      worksheet.getCell('B3').alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
      worksheet.getCell('C3').alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getCell('D3').alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getCell('E3').alignment = { vertical: 'middle', horizontal: 'left' };
      worksheet.getCell('F3').alignment = { vertical: 'middle', horizontal: 'left' };

      worksheet.getCell('A4').value = '序号';
      worksheet.getCell('A4').border = {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };
      worksheet.getCell('B4').value = '箱号';
      worksheet.getCell('B4').border = {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };
      worksheet.getCell('C4').value = '箱号条形码';
      worksheet.getCell('C4').border = {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };
      worksheet.getCell('D4').value = '数量';
      worksheet.getCell('D4').border = {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };
      worksheet.getCell('E4').value = '备注';
      worksheet.getCell('E4').border = {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };
      worksheet.getCell('F4').value = '结果统计';
      worksheet.getCell('F4').border = {
        top: {style:'thin'},
        left: {style:'thin'},
        bottom: {style:'thin'},
        right: {style:'thin'}
      };

      let  nowIndex = 5;
      for (let i = 0; i < this.boxList.length; i++) {
        worksheet.getRow(nowIndex).height = 65;
        let item = this.boxList[i];
        let index = i + 1;
        worksheet.getCell(`A${nowIndex}`).value = index + '';
        worksheet.getCell(`B${nowIndex}`).value = item.boxNo;

        const myBase64Image = item.barcode;
        const imageId2 = workbook.addImage({
          base64: myBase64Image,
          extension: 'png',
        });
        worksheet.addImage(imageId2, {
          tl: { col: 2.1, row: nowIndex - 1 + 0.5 },
          ext: { width: item.base64Obj.width, height: item.base64Obj.height }
        });
        //worksheet.addImage(imageId2, `C${nowIndex}:C${nowIndex}`);
        worksheet.getCell(`D${nowIndex}`).value = item.count + '';
        worksheet.getCell(`E${nowIndex}`).value = '';
        worksheet.getCell(`F${nowIndex}`).value = {
          'richText': [
            {'text': '前盘：'},
            {'text': ' \n 1班：    2班：    3班：    4班：'},
            {'text': ' \n 电不良：      OS： '},
            {'text': ' \n 视检不良：    废品：'},
          ]
        };

        worksheet.getCell(`A${nowIndex}`).border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        };
        worksheet.getCell(`B${nowIndex}`).border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        };
        worksheet.getCell(`C${nowIndex}`).border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        };
        worksheet.getCell(`D${nowIndex}`).border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        };
        worksheet.getCell(`E${nowIndex}`).border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        };
        worksheet.getCell(`F${nowIndex}`).border = {
          top: {style:'thin'},
          left: {style:'thin'},
          bottom: {style:'thin'},
          right: {style:'thin'}
        };
        // worksheet.getCell(`F${nowIndex}`).alignment = { wrapText: true };

        worksheet.getCell(`A${nowIndex}`).alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell(`B${nowIndex}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true  };
        worksheet.getCell(`C${nowIndex}`).alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell(`D${nowIndex}`).alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell(`E${nowIndex}`).alignment = { vertical: 'middle', horizontal: 'left' };
        worksheet.getCell(`F${nowIndex}`).alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };

        nowIndex++;
      }

      worksheet.getColumn(1).width = 15;
      worksheet.getColumn(2).width = 15;
      worksheet.getColumn(3).width = 45;
      worksheet.getColumn(5).width = 10;
      worksheet.getColumn(6).width = 35;


      workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            let name = this.editRow.subNo + '.xlsx';
            FileSaver.saveAs(blob, name);
            setTimeout(() => {
              this.loadingMain = false;
            }, 1000)
          });


      // var column = [];
      // this.$refs['outTable'].$children.forEach(element => {

      //     if(element.label && element.label!='操作') {
      //        let temp = {
      //            title: element.label,
      //            key: element.prop,       //key值对应表单数据字段名称
      //            type: 'text',
      //            }
      //        if(temp.title=='条码') {
      //            temp.type = 'image';
      //            temp.width= 200,
      //            temp.height= 100
      //        }
      //         column.push(temp)
      //     }
      // });
      // console.log(column);
      // console.log(this.boxList);
      // var datas = this.boxList;   //表单数据
      // const excelName = '学生信息_'+ new Date().toLocaleString()             //文件名称
      // table2excel(column, datas, excelName)    //生成Excel表格，自动下载

      // console.log(this.boxList)
      // console.log(this.editRow)
      // let processType = this.processTypeVal(this.editRow.processType)
      // exportBoxXlsx(this.boxList,this.editRow, processType);
    },
    exportExcel(row){
      console.log(row)
      this.dialogVisible = true
      this.editRow = row;

      // jsbarcode('#barcode', 'DY2020080400088', {
      //       format: 'CODE39',
      //       lineColor: '#000',
      //       background: '#EBEEF5',
      //       width: 2,
      //       height: 40,
      //       displayValue: false
      //     })
      this.incoStorageList(row);
    },
    async incoStorageList(row) {
      try {
        const {
          subNo,
        } = row;
        let startDate;
        let endDate;
        const res = await incoStorageList({
          page: 1,
          perpage: 2000,
          subNo: subNo || undefined,
        });
        const { data } = res;
        console.log(data);
        this.boxList = [];
        let i = 0
        for(let item of data.records){
          let img = document.createElement('canvas');
          jsbarcode(img, item.boxNo, {
                  lineColor: '#000',
                  height: 40,
                  width: 1,
                  displayValue: false
                });

          //item.barcode = img.toDataURL("image/png");
          let base64Image = img.toDataURL("image/png");
          let base64Obj = this.get_size(base64Image)
          let obj = {
            ...item,
            barcode: base64Image,
            base64Obj: base64Obj
          }
          console.log(obj);
          this.boxList.push(obj);
          i++;
        }
        // this.boxList = data.records

        // this.$nextTick(() => {
        //   let i = 0
        //   for(let item of this.boxList){
        //     // let str = '#barcode' + i;

        //     // console.log(item)
        //     // jsbarcode(str, item.boxNo, {
        //     //         lineColor: '#000',
        //     //         background: '#EBEEF5',
        //     //         width: 2,
        //     //         height: 40,
        //     //         displayValue: false
        //     //       });
        //           let img = document.createElement('canvas');
        //           jsbarcode(img, item.boxNo, {
        //                   lineColor: '#000',
        //                   background: '#EBEEF5',
        //                   width: 2,
        //                   height: 40,
        //                   displayValue: false
        //                 });

        //     item.barcode = img.toDataURL("image/png");
        //     console.log(item.barcode);
        //     i++;
        //   }

        // });

        //exportBoxXlsx(data.records);
      } catch (e) {
        // do nothing.
      }
    },
    onChangePage() {
      this.incoOrderList();
    },
    async incoOrderList() {
      try {
        const {
          incoOrderNo,
          customerId,
          productId,
          lotNo,
          orderDate,
          status,
        } = this.searchParams;
        let orderStartDate;
        let orderEndDate;
        if (orderDate && orderDate.length === 2) {
          [orderStartDate, orderEndDate] = orderDate;
        }
        const res = await incoOrderList({
          page: this.page,
          perpage: this.perpage,
          incoOrderNo: incoOrderNo || undefined,
          customerId: customerId || undefined,
          productId: productId || undefined,
          lotNo: lotNo || undefined,
          orderStartDate,
          orderEndDate,
          status: isValueEmpty(status) ? undefined : status,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        this.listData = [];
        let incoOrdersDetails;
        let length, count, prodNoChipNameSet, incoOrderDetail;
        data.records.map(item => {
          incoOrdersDetails = item.incoOrdersDetails;
          length = incoOrdersDetails.length;
          if (length === 0) {
            this.listData.push({
              ...item,
              count: 0,
            });
          } else {
            count = 0;
            prodNoChipNameSet = new Set();
            for (let i = 0; i < length; i++) {
              incoOrderDetail = incoOrdersDetails[i];
              prodNoChipNameSet.add(this.productName(incoOrderDetail));
              count += Number.parseFloat(incoOrdersDetails[i].count);
            }
            this.listData.push({
              ...item,
              count,
              prodNoChipName: [...prodNoChipNameSet],
            });
          }
        });
      } catch (e) {
        // do nothing.
      }
    },
    async customersListGet(page, perpage, customerName) {
      try {
        const res = await customersList({ page, perpage, customerName });
        const { data } = res;
        this.customersList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    async productsListGet(page, perpage) {
      try {
        const res = await productsList({ page, perpage });
        const { data } = res;
        this.productsList = data.records;
      } catch (e) {
        // do nothing.
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.incoOrderList();
    },
    queryOrderRecord() {
      this.page = 1;
      this.searchParams = {...this.form};
      this.incoOrderList();
    },
    productName(row) {
      const { product } = row;
      if (!product) {
        return '';
      }
      return `${product.productName} / ${product.chipName}`;
    },
    processTypeVal(val) {
      return this.processTypesObj[val];
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD');
      }
      return updateDate.local().format('YYYY/MM/DD');
    },
    disableDeleteIncoOrder(row) {
      return row.status !== storeStatus.noReceipt.val;
    },
    disableFinishedIncoOrder(row) {
      return row.status !== storeStatus.send.val;
    },
    deleteIncoOrder(row) {
      this.$confirm(this.$t('incomingOrder.thisActionWillDeleteThisOrder'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        try {
          const {
            incoOrderNo
          } = row;
          try {
            await incoOrderDelete({
              incoOrderNo,
            });
            this.$message({
              type: 'success',
              message: this.$t('common.deleteSuccess'),
            });
            this.incoOrderList();
          } catch (e) {
          }
        } catch (e) {
          // do nothing.
        }
      }).catch(() => {
        // do nothing.
      });
    },
    async incoOrderCanBeFinishedGet(row){
      this.$confirm(this.$t('incomingOrder.thisActionWillFinishThisOrder'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          incoOrderNo
        } = row;
        try {
          const res = await incoOrderCanBeFinishedGet({
            incoOrderNo,
          });
          this.finishIncoOrderPut(row,res.data.lossCount);
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });

    },
    async finishIncoOrderPut(row,lossCount){
      let str = '该订单损耗数量为' + lossCount + '，确定结束？';
      this.$confirm(str, this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          incoOrderNo
        } = row;
        try {
          await finishIncoOrderPut({
            incoOrderNo,
          });
          this.incoOrderList(row);
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });
    },
    async calcelFinishIncoOrderPut(row){
      this.$confirm(this.$t('incomingOrder.thisActionWillUnFinishThisOrder'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          incoOrderNo
        } = row;
        try {
          await calcelFinishIncoOrderPut({
            incoOrderNo,
          });
          this.$message({
            type: 'success',
            message: this.$t('common.success'),
          });
          this.incoOrderList();
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });
    },
    getwaitNum(row){
      let temp1 = row.incoCount - row.passCount - row.failCount;
      let temp2 = row.incoCount - row.testCount;
      let str = temp1 < temp2 ? temp1 : temp2;
      return str > 0 ? str : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .title_container {
    padding: 20px 30px;
    padding-top: 0px;
    box-sizing: border-box;
    display: inline-block;
  }
  .title_text {
    font-size: 14px;
    color: #555555;
    margin-right: 50px;
  }
  .content_text {
    margin-left: 10px;
  }
  .el-form {
    padding: 10px 20px 0;
    border-bottom: 1px solid #E5E5E5;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 10px 20px;
  }
  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 0 20px;
    height: 100%;
    overflow: auto;
  }
  .bottom-container {
    text-align: center;
    position: relative;
    margin: 20px auto;
    width: 100%;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .link.is-disabled {
    color: #C0C4CC;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
  .small_label .el-form-item__label {
    font-size: 12px;
  }
</style>
